import React from "react";
import { createColumnHelper } from "@tanstack/react-table";
import { format } from "date-fns";

const columnHelper = createColumnHelper();

const usageHistoryColumns = () => [
  columnHelper.accessor("creator_user_id", {
    header: "Creator User ID",
    headerClassName: "table-header",
    cellClassName: "table-cell",
    size: 120,
    enableSorting: false
  }),

  columnHelper.accessor("subscription_id", {
    header: "Subscription ID",
    headerClassName: "table-header",
    cellClassName: "table-cell",
    size: 140,
    enableSorting: false
  }),

  columnHelper.accessor("proposal_limit", {
    header: "Proposal Limit",
    headerClassName: "table-header",
    cellClassName: "table-cell",
    size: 140,
    enableSorting: false
  }),

  columnHelper.accessor("proposal_used", {
    header: "Proposal Used",
    headerClassName: "table-header",
    cellClassName: "table-cell",
    size: 140,
    enableSorting: false
  }),

  columnHelper.accessor("start_date", {
    header: "Start Date",
    headerClassName: "table-header",
    cellClassName: "table-cell",
    size: 180,
    enableSorting: false,
    cell: ({ getValue }) =>
      getValue() ? format(new Date(getValue()), "dd MMM yyyy") : "-"
  }),

  columnHelper.accessor("end_date", {
    header: "End Date",
    headerClassName: "table-header",
    cellClassName: "table-cell",
    size: 180,
    enableSorting: false,
    cell: ({ getValue }) =>
      getValue() ? format(new Date(getValue()), "dd MMM yyyy") : "-"
  })

  // columnHelper.accessor("created_at", {
  //   header: "Created At",
  //   headerClassName: "table-header",
  //   cellClassName: "table-cell",
  //   size: 180,
  //   enableSorting: false,
  //   cell: ({ getValue }) =>
  //     getValue() ? format(new Date(getValue()), "dd MMM yyyy") : "-"
  // }),

  // columnHelper.accessor("updated_at", {
  //   header: "Updated At",
  //   headerClassName: "table-header",
  //   cellClassName: "table-cell",
  //   size: 180,
  //   enableSorting: false,
  //   cell: ({ getValue }) =>
  //     getValue() ? format(new Date(getValue()), "dd MMM yyyy") : "-"
  // })
];

export default usageHistoryColumns;
